import { errorTypes } from '@/configuration/pages/ConfigurationPage/ReturnPolicy/PolicyRulesConfiguration/PolicyRuleDetailConfiguration/constants'

export const consentModalTextFields = [
  {
    key: 'consent_title',
    errorType: errorTypes.actionConsentTitleEmpty,
    title: 'Título del mensaje',
    description: 'El encabezado que se muestra en la parte superior del bloque de consentimiento.',
  },
  {
    key: 'consent_description',
    errorType: errorTypes.actionConsentDescriptionEmpty,
    title: 'Descripción del mensaje',
    description: 'El mensaje que lee el customer antes de aceptar — explica qué ocurre si continúa.',
  },
  {
    key: 'consent_checkbox_text',
    errorType: errorTypes.actionConsentCheckboxTextEmpty,
    title: 'Texto del checkbox',
    description: 'La afirmación exacta que el customer confirma al marcar la casilla.',
  },
]
